import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'pbb-card',
    standalone: true,
    templateUrl: './pbb-card.component.html',
    styleUrls: ['./pbb-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCardModule]
})
export class PbbCardComponent {}
